/* GLM × Kimonix geo order — logic only.
 * The live GLM collection template renders every card. This script only asks
 * Kimonix for the visitor's country order and re-arranges those cards.
 * Design, filters, sort menu, view switch and pagination look stay native.
 *
 * Needs window.GLM_KX_GEO from snippets/kimonix-geo-config.liquid:
 *   { shop, handle, id, country, pageSize, sectionId }
 * Optional but recommended: data-product-id on .coll_matrix_item (faster than the
 * handle fallback, which maps handles to ids through /collections/<handle>/products.json).
 */
(function () {
  'use strict';
  var cfg = window.GLM_KX_GEO;
  if (!cfg || window.__glmKxGeoLoaded) return;
  window.__glmKxGeoLoaded = true;

  var API = 'https://api.kimonix.com/get_sorted_collection_product_ids';
  var LIST_SEL = '#Collection .productList .collection_matrix_list';
  var ITEM_SEL = '.coll_matrix_item';
  var PAGE = Number(cfg.pageSize) || 12;
  var SECTION = cfg.sectionId || 'collection-template';
  var API_TIMEOUT = 2500;
  var CACHE_TTL = 5 * 60 * 1000;
  var MAX_PAGES = 25;
  var COUNTRY = String(cfg.country || (window.Shopify && window.Shopify.country) || 'US').toUpperCase();

  var busy = false;        // true while this script writes into the list
  var pool = [];           // sorted product cards not yet shown
  var sentinel = null;
  var observer = null;
  var pendingStyle = document.getElementById('glm-kx-pending');

  // MutationObserver callbacks run after the current task, so busy must stay
  // true until the next macrotask or our own writes would re-trigger run().
  function releaseBusy() { setTimeout(function () { busy = false; }, 0); }

  function showGrid() {
    if (pendingStyle && pendingStyle.parentNode) pendingStyle.parentNode.removeChild(pendingStyle);
    pendingStyle = null;
    var list = document.querySelector(LIST_SEL);
    if (list && list.style.opacity === '0') list.style.opacity = '';
  }
  function hideList(list) { list.style.opacity = '0'; } // re-runs after a filter change: no native-order flash
  function log() { if (window.GLM_KX_DEBUG && window.console) console.log.apply(console, ['[kx-geo]'].concat([].slice.call(arguments))); }

  function sortParam() {
    var m = /[?&]sort_by=([^&]*)/.exec(location.search);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function visitorChoseSort() {
    var s = sortParam();
    return !!s && s !== 'manual';
  }
  function displayMode() {
    var cb = document.querySelector('.view_wrappers #btn-view');
    return cb && cb.checked ? 'product' : 'model';
  }

  /* ---------- Kimonix order (same request the Kimonix block sends) ---------- */
  function readJSON(key, fallback) {
    try { var v = JSON.parse(localStorage.getItem(key) || 'null'); return v === null ? fallback : v; } catch (e) { return fallback; }
  }
  function cacheKey() { return 'glmkx:' + cfg.handle + ':' + COUNTRY; }
  function fetchOrder() {
    try {
      var c = JSON.parse(sessionStorage.getItem(cacheKey()) || 'null');
      if (c && c.t && Date.now() - c.t < CACHE_TTL && Array.isArray(c.ids)) return Promise.resolve(c.ids);
    } catch (e) {}
    var body = { shop: cfg.shop, collection_handle: cfg.handle, country: COUNTRY, limit: 2000 };
    if (cfg.id) body.collection_id = cfg.id;
    var handles = readJSON('kimonix_merch_last_viewed_product_handles', []);
    if (Array.isArray(handles) && handles.length) body.product_handles = handles;
    var ids = readJSON('kimonix_merch_last_viewed_product_ids', []);
    if (Array.isArray(ids) && ids.length) body.viewed_product_ids = ids;
    var uid = null;
    try { uid = localStorage.getItem('kimonix_merch_uid'); } catch (e) {}
    if (uid) body.kimonix_merch_uid = parseInt(uid, 10);

    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, API_TIMEOUT) : null;
    return fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('kimonix http ' + r.status); return r.json(); })
      .then(function (j) {
        if (timer) clearTimeout(timer);
        var list = j && (j.products || j.product_ids);
        if (!Array.isArray(list) || !list.length) throw new Error('kimonix empty answer');
        try { sessionStorage.setItem(cacheKey(), JSON.stringify({ t: Date.now(), ids: list })); } catch (e) {}
        return list;
      });
  }

  /* ---------- product id per card ---------- */
  var handleMap = null;
  function handleFromUrl(u) {
    var m = /\/products\/([^\/?#]+)/.exec(u || '');
    return m ? m[1] : '';
  }
  function needHandleMap(cards) {
    for (var i = 0; i < cards.length; i++) if (!cards[i].getAttribute('data-product-id')) return true;
    return false;
  }
  function loadHandleMap() {
    if (handleMap) return Promise.resolve(handleMap);
    var map = {};
    function page(n) {
      return fetch('/collections/' + cfg.handle + '/products.json?limit=250&page=' + n)
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j && j.products) || [];
          ps.forEach(function (p) { map[p.handle] = p.id; });
          return ps.length === 250 && n < 8 ? page(n + 1) : map;
        });
    }
    return page(1).then(function (m) { handleMap = m; return m; });
  }
  function idOf(card) {
    var a = card.getAttribute('data-product-id');
    if (a) return String(a);
    var h = handleFromUrl(card.getAttribute('data-url') || (card.querySelector('a[href*="/products/"]') || {}).getAttribute && card.querySelector('a[href*="/products/"]').getAttribute('href'));
    return handleMap && handleMap[h] ? String(handleMap[h]) : '';
  }

  /* ---------- other pages, server-rendered by the same Liquid ---------- */
  function pageUrl(n) {
    var p = new URLSearchParams(location.search);
    p.set('section_id', SECTION);
    p.set('page', String(n));
    return location.pathname + '?' + p.toString();
  }
  function fetchPage(n) {
    return fetch(pageUrl(n), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('.collection_matrix_list');
        var cards = list ? [].slice.call(list.querySelectorAll(ITEM_SEL)) : [];
        var hasNext = !!doc.querySelector('.infinitpagin a, .pagination a');
        return { cards: cards, hasNext: hasNext };
      });
  }
  function fetchRemainingPages(firstPageHasNext) {
    if (!firstPageHasNext) return Promise.resolve([]);
    var all = [];
    function step(n) {
      if (n > MAX_PAGES) return all;
      return fetchPage(n).then(function (res) {
        var products = res.cards.filter(function (c) { return !c.classList.contains('extra_grid'); });
        all = all.concat(products);
        return (res.cards.length && res.hasNext && products.length) ? step(n + 1) : all;
      });
    }
    return step(2);
  }

  /* ---------- rendering with the theme's own hooks ---------- */
  function afterAppend(list) {
    var mode = displayMode();
    try { if (typeof initProductImageSliders === 'function') initProductImageSliders(list); } catch (e) { log('sliders', e); }
    try { if (window.resetProductSliders) window.resetProductSliders(list, mode); } catch (e) { log('slider view', e); }
    try { if (window.jQuery && window.theme) { jQuery(theme.ajaxCart); jQuery(theme.colorSwatches); } } catch (e) { log('theme hooks', e); }
    try { if (typeof productGridView === 'function') productGridView(SECTION); } catch (e) { log('gridView', e); }
    try { if (typeof productGridTitlePos === 'function') productGridTitlePos(); } catch (e) { log('titlePos', e); }
  }
  function appendNext(list) {
    if (!pool.length) { removeSentinel(); return; }
    busy = true;
    var frag = document.createDocumentFragment();
    pool.splice(0, PAGE).forEach(function (c) { frag.appendChild(c); });
    list.appendChild(frag);
    afterAppend(list);
    releaseBusy();
    if (!pool.length) { removeSentinel(); return; }
    // The sentinel may still be inside the viewport after the append; an
    // IntersectionObserver only reports changes, so re-observe to get a fresh reading.
    if (sentinel && sentinel._io) { sentinel._io.unobserve(sentinel); sentinel._io.observe(sentinel); }
  }
  function removeSentinel() {
    if (sentinel) { if (sentinel._io) sentinel._io.disconnect(); if (sentinel.parentNode) sentinel.parentNode.removeChild(sentinel); sentinel = null; }
  }
  function placeSentinel(list) {
    removeSentinel();
    if (!pool.length) return;
    sentinel = document.createElement('div');
    sentinel.className = 'glm-kx-sentinel';
    sentinel.style.cssText = 'width:100%;height:1px;clear:both;';
    list.parentNode.insertBefore(sentinel, list.nextSibling);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) appendNext(list);
      }, { rootMargin: '600px 0px' });
      io.observe(sentinel);
      sentinel._io = io;
    } else {
      appendNext(list); // very old browsers: just show everything progressively
      while (pool.length) appendNext(list);
    }
  }
  // Keep the theme's pagination containers (its ajax filter refills them) but
  // disarm the links so theme.js infiniteScroll()/loadMore() never append native pages.
  function disarmThemePagination() {
    [].forEach.call(document.querySelectorAll('#Collection .infinitpagin a, #Collection .pagination a'), function (a) {
      a.classList.remove('infinite', 'loadMore');
      a.removeAttribute('href');
      a.style.display = 'none';
    });
  }

  /* ---------- main ---------- */
  var runId = 0;
  function run() {
    var my = ++runId;
    var list = document.querySelector(LIST_SEL);
    if (!list) { showGrid(); return; }
    if (visitorChoseSort()) { log('visitor sort, native order kept'); showGrid(); return; }

    var firstCards = [].slice.call(list.querySelectorAll(ITEM_SEL));
    if (!firstCards.length) { showGrid(); return; }
    if (list.getAttribute('data-kx-ordered') === '1') return; // already our output
    if (my > 1) { hideList(list); setTimeout(function () { if (my === runId) showGrid(); }, API_TIMEOUT + 1500); }
    var hasNext = !!document.querySelector('#Collection .infinitpagin a, #Collection .pagination a');

    var extras = [];
    firstCards.forEach(function (c, i) { if (c.classList.contains('extra_grid')) extras.push({ at: i, el: c }); });
    var firstProducts = firstCards.filter(function (c) { return !c.classList.contains('extra_grid'); });

    Promise.all([
      fetchOrder(),
      fetchRemainingPages(hasNext),
      needHandleMap(firstProducts) ? loadHandleMap() : Promise.resolve(null)
    ]).then(function (res) {
      if (my !== runId) return; // a newer run (filter change) replaced this one
      var order = res[0], rest = res[1];
      var rank = {};
      order.forEach(function (id, i) { rank[String(id)] = i; });

      var seen = {};
      var all = firstProducts.concat(rest).filter(function (c) {
        var id = idOf(c) || ('url:' + c.getAttribute('data-url'));
        if (seen[id]) return false; seen[id] = true; return true;
      });
      var ranked = all.map(function (c, i) {
        var id = idOf(c);
        return { c: c, r: (id in rank) ? rank[id] : (1e9 + i) };
      }).sort(function (a, b) { return a.r - b.r; });
      pool = ranked.map(function (x) { return x.c; });
      log('ordered', pool.length, 'cards for', COUNTRY, '(kimonix ids', order.length + ')');

      busy = true;
      list.setAttribute('data-kx-ordered', '1');
      list.innerHTML = '';
      var frag = document.createDocumentFragment();
      var firstBatch = pool.splice(0, PAGE);
      extras.forEach(function (x) { firstBatch.splice(Math.min(x.at, firstBatch.length), 0, x.el); });
      firstBatch.forEach(function (c) { frag.appendChild(c); });
      list.appendChild(frag);
      disarmThemePagination();
      afterAppend(list);
      releaseBusy();
      showGrid();
      placeSentinel(list);
    }).catch(function (err) {
      log('fallback to native order:', err && err.message);
      if (my === runId) showGrid();
    });
  }

  function watch() {
    // The theme's <colle-filter> replaces the innerHTML of .collection_matrix (a new
    // .collection_matrix_list element each time) and ajaxfilter() refills the list,
    // so watch the stable parent with subtree and re-run after the theme is done.
    var host = document.querySelector('#Collection .collection_matrix') || (document.querySelector(LIST_SEL) || {}).parentNode;
    if (!host || observer) return;
    var t = null;
    observer = new MutationObserver(function () {
      if (busy) return;
      clearTimeout(t);
      t = setTimeout(run, 80);
    });
    observer.observe(host, { childList: true, subtree: true });
  }

  function start() { run(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  setTimeout(showGrid, API_TIMEOUT + 1500); // never leave the grid hidden
})();
